import React from "react";
import MDTypography from "components/MDTypography";

const days = [
  "Sunday", // 1
  "Monday", // 2
  "Tuesday", // 3
  "Wednesday", // 4
  "Thursday", // 5
  "Friday", // 6
  "Saturday", // 7
];

export default function CTLDay({ value }) {
 
  const index = value === 0 ? -1 : value - 1;
  const day = days[index] || "";

  return (
    <MDTypography variant="caption" fontWeight="medium" color="text">
      {day}
    </MDTypography>
  );
}

CTLDay.defaultProps = {
  suffix: "",
};
